<template>
    <v-container fluid class="align-center column" style="height: auto">
        <div class="column screen-width" style="gap: 40px; padding: 60px 0px">
            <p style="font-size: 32px; font-weight: bold">비밀번호 찾기</p>

            <div class="login-view align-center column">
                <div class="input-user column align-center">
                    <div class="row align-space-between" style="width:100%">
                         <p style="font-size: 28px; font-weight: bold"> 이름</p>
                        <input
                            v-model="name"
                            class="input-form"
                            type="text"
                            @click="target = 0"
                        />
                    </div>

                    <div class="row align-space-between" style="width:100%">
                        <p style="font-size: 28px; font-weight: bold"> 이메일 </p>
                        <input
                            v-model="email"
                            class="input-form"
                            type="text"
                            @click="target = 1"
                        />
                    </div>
                </div>

                <div class="button">
                    <v-btn color="info" width="600" height="70%" @click="findPassword">
                        비밀번호 찾기
                    </v-btn>
                </div>

                <div v-if="result" class="column align-center" style="width:100%; gap:32px">
                    <div style="width:50%; height:1px; background:gray">
                    </div>
                    <p style="font-size:20px;">{{result}} </p>
                </div>
            </div>
        </div>
    </v-container>
</template>

<script>
import { useStore } from "vuex";
import { ref } from "vue";

export default {
    components: {},
    setup() {
        const store = useStore();
        const name = ref("");
        const email = ref("");
        const result = ref(null);

        const findPassword = () => {
            store.dispatch("findPassword", {
                name: name.value,
                email: email.value
            }).then((res) => {
                result.value = res;
            }).catch((err) => {
                result.value = err;
            })
        }

        return {
            name,
            email,
            findPassword,
            result
        };
    },
};
</script>

<style scoped>
.container {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 50%;
    min-width: 300px;
    min-height: 400px;
    position: relative;
    z-index: 1;
}
.container::after {
    content: "";
    width: 25%;
    height: 50%;
    min-width: 300px;
    min-height: 400px;
    position: absolute;
    /* background-image: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0) ),
    url(@/assets/background_img.jpg); */
    background-repeat: no-repeat;
    background-size: cover;
    z-index: -1;
    opacity: 0.6;
}
.login-view {
    width: 100%;
    height: 500px;
    background: white;
    border: 2px solid rgba(0, 0, 0, 0.2);
    border-radius: 10px;
    gap:24px;
}

.logo-view {
    width: 100%;
    text-align: center;
    height: 45%;
}

.input-user {
    width: 50%;
    text-align: center;
    height: auto;
}

.input-form {
    width: 60%;
    border: 1px solid black;
    height: 64px;
    margin: 10px;
    text-indent: 15px;
}

.button {
    width: 100%;
    height: 20%;
    display: flex;
    justify-content: center;
}
</style>
